module.exports = __webpack_public_path__ + "static/media/wand-magic.d6e00e28.svg";